import { render, staticRenderFns } from "./CashDeskMock.vue?vue&type=template&id=1143fb74&lang=pug&"
import script from "./CashDeskMock.vue?vue&type=script&lang=js&"
export * from "./CashDeskMock.vue?vue&type=script&lang=js&"
import style0 from "./CashDeskMock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CashDeskMock.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFadeTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSlideXReverseTransition } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VDivider,
  VFadeTransition,
  VFlex,
  VLayout,
  VSlideXReverseTransition,
  VTextField,
  VToolbar,
})
